import { RouteType } from "types/RouteType";
import DeliveryConnectionsStore from "./DeliveryConnectionsStore";

const deliveryConnectionsRoute: RouteType[] = [
  {
    name: "DeliveryConnections",
    path: "/meeting-delivery-connections",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Delivery Connections",
        enableRefreshButton: true,
        component: () => import("./DeliveryConnections.Header"),
      },
      body: {
        component: () => import("./DeliveryConnections.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    searchAliases: ["read.ai delivery", "meeting delivery"],
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      (rootStore.deliveryConnectionsAdminStore as DeliveryConnectionsStore)?.load();
    },
  },
];

export default deliveryConnectionsRoute;
